import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { writtenWorks } from '../components/WrittenWorks';

export default function WrittenWorkDetail() {
  const { id } = useParams<{ id: string }>();
  const work = writtenWorks.find(w => w.id === id);

  if (!work) {
    return (
      <div style={{ padding: '2rem', textAlign: 'center' }}>
        <h2>Work not found</h2>
        <p>The written work you're looking for doesn't exist.</p>
        <Link to="/written-works">Back to Written Works</Link>
      </div>
    );
  }

  const WorkComponent = work.component;

  return (
    <div>
      <Link to="/written-works" style={{ display: 'block', padding: '1rem 2rem', textDecoration: 'none' }}>
        ← Back to Written Works
      </Link>
      <WorkComponent />
    </div>
  );
}
